import React, { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import { Environments } from 'src/configurations'
import { useCurrencyFormatter } from 'src/localization/useCurrencyFormatter'
import { useTranslate } from 'src/localization/useTranslate'
import { Rdrct } from 'src/navigation/Lnk'
import { signinUrl } from 'src/navigation/urls'
import { selectEnvironmentFromState } from 'src/redux/selectors/session.selectors'

import { MarcomPricingPageContent } from './MarcomPricingPageContent'

export default function MarcomPricingPage(): ReactElement {
  const environment = useSelector(selectEnvironmentFromState)
  const currencyFormatter = useCurrencyFormatter()
  const translate = useTranslate()

  if (environment === Environments.Prod) {
    return <Rdrct to={signinUrl()} />
  }

  return (
    <MarcomPricingPageContent
      currencyFormatter={currencyFormatter}
      translate={translate}
    />
  )
}
